import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { GenericConfig} from '@signature-it/ngx-generic/config';
import { IUser } from '@signature-it/ngx-generic/interfaces';
import {Router} from "@angular/router";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {POSLineProductsModalComponentGeneric} from '@signature-it/ngx-catalogue/components/pos-line-products-modal';

@Component({
    selector: 'cart-continue-actions',
    templateUrl: './cart-continue-actions.component.html',
    styleUrls: ['./cart-continue-actions.component.scss'],
    standalone: false
})
export class CartContinueActionsGenericComponent implements OnInit {

    @Input() user: IUser;
    @Input() isContinueToCheckout: boolean;
    @Input() checkoutMessage: string;
    @Input() guestInCheckout: boolean = true;
    @Input('items') items = {
        TransactionItems: Array<object>(),
        allItems: Array<object>(),
        OrderItems: Array<object>()
    };
    @Input() onContinueActionClicked?: (callback: (result: boolean) => void) => void;

    POSLineProducts: any = GenericConfig.POSLineProducts;
    dialogRef: MatDialogRef<POSLineProductsModalComponentGeneric>;

    constructor(
        protected router: Router,
        public dialog: MatDialog
    ) {
    }

    ngOnInit() {

    }

    continueToCheckout() {
        if (this.onContinueActionClicked) {
            this.onContinueActionClicked((result: boolean) => {
                if (result) {
                    this.goToCheckout();
                }
            });
        } else {
            this.goToCheckout();
        }
    }

    goToCheckout(){
        if (this.POSLineProducts) {
            this.dialogRef = this.dialog.open(
                POSLineProductsModalComponentGeneric,
                {data: {POSLineProducts: this.POSLineProducts}, panelClass: 'pos-line-product-dialog'});
            this.dialogRef.afterClosed().subscribe(dialogResult => {
                this.router.navigate(['/cart/checkout']);
            });
        } else {
            this.router.navigate(['/cart/checkout']);
        }
    }

    continueToLogin() {
        if (this.onContinueActionClicked) {
            this.onContinueActionClicked((result: boolean) => {
                if (result) {
                    this.goToLogin();
                }
            });
        } else {
            this.goToLogin();
        }
    }

    goToLogin(){
        if (this.POSLineProducts) {
            this.dialogRef = this.dialog.open(
                POSLineProductsModalComponentGeneric,
                {data: {POSLineProducts: this.POSLineProducts}});
            this.dialogRef.afterClosed().subscribe(dialogResult => {
                this.router.navigate(['/login'], { queryParams: {redirect: '/cart/checkout'}});
            });
        } else {
            this.router.navigate(['/login'], { queryParams: {redirect: '/cart/checkout'}});
        }
    }
}
